import { render, staticRenderFns } from "./Histograms.vue?vue&type=template&id=5a6750e4&"
import script from "./Histograms.vue?vue&type=script&lang=js&"
export * from "./Histograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports